

/// <reference path="StockNote.ts" />

// Generated class MovementNote_ManagedObject

class MovementNote_ManagedObject extends StockNote
{
}
